export const PAGINATION_PAGE_SIZE_DEFAULT = 100;

export const PAGINATION_SORT_DIRECTION = ['ASC', 'DESC'] as const;

export type PaginationSortDirection =
  (typeof PAGINATION_SORT_DIRECTION)[number];
